import { http, setHTTPHeader } from './http.service';
import { ILeague } from '@/types/general';
import { create, fetch, fetchAll, getWaivers } from '@/apis/league.api';

class LeagueService {
  async create(league: ILeague) {
    return create(league);
  }

  async fetchAll(account_id, include_interleague) {
    return fetchAll(account_id, include_interleague);
  }

  async fetch(leagueId) {
    return fetch(leagueId);
  }

  async getWaivers(leagueId, language) {
    return getWaivers(leagueId, language)
  }
}

const instance = new LeagueService();
export default instance;
